import React from 'react';
import CountUpCommon, { CountUpProps } from 'react-countup';

export default function CountUp(props: CountUpProps) {
  return <CountUpCommon {...props} />;
}
